module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1266.2c7f5c75.png";